/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, May 2021
 * @format
 * @flow
 */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Group, Rect, Transformer, Text as KonvaText } from 'react-konva';
import tranformerConfig from './tranformerConfig';

//Table description:- Table_8_Rect_2_2_2_2_0Deg
//Table_<seat capacity>_<table type>_<seat arrangement>_<angle>Deg
const Table_8_Rect_2_2_2_2_0Deg = props => {
  const {
    shapeProps,
    isSelected,
    onSelect,
    onChange,
    draggable,
    tableInfoColumn,
    keyName1,
    keyName2,
    keyName3,
  } = props;
  const { x, y, scaleX, scaleY, rotation, stroke, strokeWidth } = shapeProps;
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (draggable && isSelected) {
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const onDragEnd = e => {
    onChange && onChange({
      ...shapeProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  const onTransformEnd = e => {
    //transformer is changing scale
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);
    onChange && onChange({
      ...shapeProps,
      x: node.x(),
      y: node.y(),
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: node.rotation(),
    });
  };

  return (
    <>
      <Group
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        x={x}
        y={y}
        scaleX={scaleX}
        scaleY={scaleY}
        rotation={rotation}
        draggable={draggable}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
      >
        <Rect x={20} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={80} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={130} y={20} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={130} y={80} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={20} y={130} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={80} y={130} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={0} y={20} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={0} y={80} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={10} y={10} stroke={stroke} strokeWidth={strokeWidth} width={120} height={120} />
        {tableInfoColumn && <KonvaText text={shapeProps[tableInfoColumn]} x={45} y={60} fill={stroke} fontSize={25} />}
        {keyName1 && <KonvaText text={shapeProps[keyName1]} x={45} y={16} fill={'white'} fontSize={14} />}
        {keyName2 && <KonvaText text={shapeProps[keyName2]} x={45} y={110} fill={'white'} fontSize={14} />}
        {keyName3 && <KonvaText text={shapeProps[keyName3]} x={110} y={60} fill={'white'} fontSize={14} />}
      </Group>
      {draggable && isSelected && <Transformer ref={trRef} {...tranformerConfig} />}
    </>
  );
};

export default Table_8_Rect_2_2_2_2_0Deg;

Table_8_Rect_2_2_2_2_0Deg.propTypes = {
  shapeProps: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  draggable: PropTypes.bool,
  tableInfoColumn: PropTypes.string,
};

Table_8_Rect_2_2_2_2_0Deg.defaultProps = {
  shapeProps: {},
  isSelected: false,
  onSelect: () => { },
  onChange: () => { },
  draggable: true,
};
